"use strict";

import "./ContextMenu.css";
import Bubble from "./../Bubble";
import zIndex from "./../zIndex";

const MAX_WIDTH = 200;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {Object[]} params.items
			@param {String} params.items.label
			@param {Function} onClick
*/

export default class ContextMenu extends Bubble {
	
	constructor( params={} ) {
		
		if (!params.map)
			throw new Error("Missing map");
		
		if (!params.position)
			throw new Error("Missing position");
		
		const menu = document.createElement("ul");
		menu.classList.add("Map", "ContextMenu");
		
		super({
			map:		params.map,
			position:	params.position,
			content:	menu,
			maxWidth:	ContextMenu.MAX_WIDTH,
			zIndex:		zIndex.CONTEXT_MENU
		});
		
		this.menu = menu;
		this.setItems(params.items);
		
		google.maps.event.addListenerOnce(params.map, 'click', this.close.bind(this));
		google.maps.event.addListenerOnce(params.map, 'rightclick', this.close.bind(this));
	}

	setItems(items) {
		this.items = items.map(item => this.createItem(item));
	}
	
	createItem(item) {
		const li = document.createElement("li");
		li.textContent = item.label;
		li.onclick = _ => {
			item.onClick();
			this.close();
		};
		this.menu.appendChild(li);
		return li;
	}
}


// WEBPACK FOOTER //
// ./src/view/Map/ContextMenu/ContextMenu.js